import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import FadeIn from "../components/FadeIn";
import SEO from "../components/SEO";

export default function ConnectExplainedPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="connect-explained-page">
      <SEO title="How Connection Works" path="/connect" description="Connection on HAEVN happens when both people choose to take the next step. It's mutual, intentional, and designed for real outcomes." />
      <Navigation />

      <section className="pt-20 pb-12 md:pt-28 md:pb-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <h1 className="font-headline text-4xl sm:text-5xl text-haevn-navy">How connection works</h1>
          </FadeIn>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <section className="py-20 px-6 md:px-12 bg-[#F8F7F5]">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <p className="text-base md:text-lg text-gray-700 font-body mb-4 leading-relaxed">
              A connection happens when both people choose to connect.
            </p>
            <p className="text-base md:text-lg text-gray-700 font-body leading-relaxed">
              Once connected, full profiles and photos unlock.
            </p>
          </FadeIn>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <section className="py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <p className="text-xl md:text-2xl text-haevn-navy font-subhead leading-relaxed">
              Connection is mutual by design
            </p>
          </FadeIn>
        </div>
      </section>

      <Footer />
    </div>
  );
}
